/** Country comes from CloudFront, never from page language or browser locale. */
export async function fetchVisitorCountry(
  apiBaseUrl: string,
  signal: AbortSignal
): Promise<string | null> {
  const response = await fetch(
    `${apiBaseUrl.replace(/\/$/, '')}/v1/external/website-visitor-context`,
    { cache: 'no-store', credentials: 'omit', signal }
  );
  if (!response.ok)
    throw new Error(`Visitor country lookup: HTTP ${response.status}`);
  const context: { countryCode: string | null } = await response.json();
  return context.countryCode;
}

export function isTaiwanVisitor(countryCode: string | null): boolean {
  return countryCode === 'TW';
}
